import { backendApi } from "@/services/backend/api";
import {
  DocumentBaseFilters,
  DocumentCommonFilters,
} from "@/services/backend/documents/types/filters";
import { Filter } from "@/shared/lib/filter/filter";
import { Lst } from "@/shared/lib/lst/lst";
import { DocumentKind, ServiceKind } from "@bitory-gmbh/bsm";
import { Document } from "../types/document";

const documentApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    documentsList: build.query<Lst<Document>, ListRequest>({
      query: (request) => ({
        url: `document/list`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: [{ type: "Document", id: "LIST" }],
    }),
  }),
});

export const { useDocumentsListQuery } = documentApi;

/**
 * ListRequest lists documents across one or more service and document
 * kinds. Leaving the serviceKind / documentKind filters inactive lists
 * every supported kind, which - combined with a serviceObject filter -
 * yields all documents linked to a service object.
 */
export interface ListRequest
  extends DocumentBaseFilters, DocumentCommonFilters {
  serviceKind?: Filter<ServiceKind>;
  documentKind?: Filter<DocumentKind>;
  limit?: number;
  offset?: number;
}
